import { currencyFilter } from '@/utils/filters';
export default {
    name: 'MyProposal',
    data: () => ({
        observation: '',
        proposalValue: '',
        attachments: []
    }),
    props: { show: Boolean, width: String, height: String, isMobile: Boolean, competition: Object },
    methods: {
        currencyFilter
    }
};
